import { TextInput, SimpleGrid, Title, Select, Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useCreateRuleFormContext } from 'context/FormContext';
import { Priority, RuleFrequencies, RuleTriggers } from 'models/rules';
import { snakeCase } from 'lodash';
import { displayFormError } from 'utils/validation';

export const BasicInfoFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const selectableFrequencies =
    values.trigger !== RuleTriggers.timeSincePrescription
      ? Object.entries(RuleFrequencies)
      : Object.entries(RuleFrequencies).filter(([key]) => key !== RuleFrequencies.occurrence);

  return (
    <>
      <Title order={4} mb={-10}>
        {t('basic_info_label')}
      </Title>
      <SimpleGrid cols={2}>
        <TextInput
          label={t('rule_name_label')}
          placeholder={!errors.name ? t(`${snakeCase(values.trigger)}_label`) : ''}
          {...getInputProps('name')}
          disabled={values.formDisabled}
          error={displayFormError({ errors, dataField: 'name', label: t('empty_value_text') })}
        />
        <TextInput
          label={t('description_label')}
          placeholder={!errors.description ? t('rule_description_placeholder') : ''}
          {...getInputProps('description')}
          disabled={values.formDisabled}
          error={displayFormError({ errors, dataField: 'description', label: t('empty_value_text') })}
        />
      </SimpleGrid>
      <Group justify={'flex-start'}>
        <Select
          label={t('priority_label')}
          data={Object.entries(Priority).map(([key, value]) => ({
            value: value.toString(),
            label: t(`${key.toLowerCase()}_label`),
          }))}
          {...getInputProps('priority')}
          disabled={values.formDisabled}
        />
        <Select
          label={t('frequency_label')}
          data={selectableFrequencies.map(([key, value]) => ({
            value: value.toString(),
            label: t(`frequency_${key}_label`),
          }))}
          {...getInputProps('frequency')}
          disabled={values.formDisabled}
        />
      </Group>
    </>
  );
};
